import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { NegotiationData } from "../types/negotiations.type";

type UseNegotiationType = (id?: string) => UseQueryResult<NegotiationData, unknown>;

const useNegotiation: UseNegotiationType = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: NegotiationData } }, unknown, NegotiationData>({
    queryKey: ['negotiations', id],
    queryFn: () => privateAxios.get(`/client/negotiations/${id}`),
    select: (data) => data?.data?.data,
    retry: 0,
  });
};

export default useNegotiation;
